<div class="navbar-brand header-logo">
    <!-- <a [routerLink]="['/dashboard/dash-customer/']" class="b-brand">
        <div class="b-bg">
        <i class="feather icon-activity"></i>
        </div>
        <span class="b-title">FORTEC</span>
    </a> -->
    <a href="javascript:" class="mobile-menu" [ngClass]="{'on' : navCollapsed}" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
</div>
